/**
 * @desc exportByQuery
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSn.exportByQuery.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/exportByQuery`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
